export default defineNuxtPlugin(() => {
  const { show, hide, state } = useBottomFix()

  return {
    provide: {
      bottomFix: {
        state,
        show,
        hide,
      },
    },
  }
})
